import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
/**
 * Icon button atom.
 */
export class IconButtonComponent {
  private _disabled: boolean = false;

  @Input() icon?: string;
  @Input() formGroup?: UntypedFormGroup;
  @Output() clickAction = new EventEmitter<any>();

  /**
   * Whether this button is disabled or not
   */
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  /**
   * Sets this button as disabled
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set disabled(value: any) {
    this._disabled = coerceBooleanProperty(value);
  }

  /**
   * Emits click action event for underlying material button
   */
  emitClick() {
    this.clickAction.emit();
  }

  /**
   * If this button should be disabled or not
   * @return {boolean}
   */
  isDisabled(): boolean {
    return this.disabled || (Boolean(this.formGroup) && !this.formGroup?.valid);
  }
}
